/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';

import LoginPasswordForm from './LoginPasswordForm';
import LoginUsernameForm from './LoginUsernameForm';
import { authenticationPasswordForm } from 'src/shared/app/authentication/constant/uiAuthenticationConstants';
import logInMessages from 'src/shared/app/authentication/l10n/logInL10n';
import resetMessages from 'src/shared/app/authentication/l10n/resetPasswordL10n';
import SuccessBanner from 'src/shared/app/base/component/notification/SuccessBanner';
import Notification from 'src/shared/app/base/component/template/component/Notification';
import ZIndexTopBar from 'src/shared/app/base/component/template/component/TopBar';
import useRoutes from 'src/shared/app/base/route/hook/useRoutes';
import { signupRoute } from 'src/shared/app/base/route/setting/routeSettings';
import useFeatureDecisions from 'src/shared/app/feature/hook/useFeatureDecisions';
import LazySignupMain from 'src/shared/app/signup/component/LazySignupMain';
import TopBar, {
  backButton,
} from 'src/shared/app/nav/component/top-bar/TopBar';
import Footer from 'src/shared/app/onboarding/component/footer/Footer';

type Props = {
  section: ?string,
  isPasswordSet: boolean,
  isPasswordReset: boolean,
  handleBack: () => void,
};

const LoginWizardDumb = (props: Props): React.Node => {
  const { section, isPasswordSet, isPasswordReset, handleBack } = props;
  const isPasswordSection = section === authenticationPasswordForm;

  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();
  const { isSignupEnabled } = useFeatureDecisions();
  const [signupPath] = useRoutes(signupRoute);

  const title = intl.formatMessage(
    !isPasswordSection || isPasswordSet
      ? logInMessages.heading
      : logInMessages.newPasswordHeading,
  );

  /*
   |----------------------------------------------------------------------------
   | Effects
   |----------------------------------------------------------------------------
   */

  React.useEffect(() => {
    if (isSignupEnabled) {
      LazySignupMain.preload();
    }
  }, [isSignupEnabled]);

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const bannerElt = isPasswordReset ? (
    <Notification>
      <SuccessBanner text={intl.formatMessage(resetMessages.success)} />
    </Notification>
  ) : null;

  const formElt = isPasswordSection ? (
    <LoginPasswordForm />
  ) : (
    <LoginUsernameForm />
  );

  return (
    <React.Fragment>
      <ZIndexTopBar>
        <TopBar
          title={title}
          actionLabel={
            isSignupEnabled ? intl.formatMessage(logInMessages.signup) : null
          }
          actionRoute={isSignupEnabled ? signupPath : null}
          handleCancel={section ? handleBack : null}
          variant={section ? backButton : null}
        />
      </ZIndexTopBar>
      {bannerElt}
      {formElt}
      <Footer />
    </React.Fragment>
  );
};

export default compose(React.memo)(LoginWizardDumb);
